import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import data from "../../../../../../Json/Language/English";
import hindiDatas from "../../../../../../Json/Language/Hinid";
// import "../../../../StyleSheet/Mainstylesheet/Salary/PaySlip/PaySlip.scss";
import { useNavigate } from "react-router-dom";
import HeadingComp from "../../../UdsEmployeeDashboard/CustomHooks/useLanguageSelector";
import { SetFetchReimbursementEMPAction } from "../../../../../../Redux/Slice";
import useLanguageSelector from "../../../UdsEmployeeDashboard/CustomHooks/useLanguageSelector";
import ReimbursementPopup from "./ReimbursementPopup";
import ReactTable from "../../../../../AppComponent/Table";
import _, { values } from "lodash";
import approved from "../../../../../../Assets/MainComponent/approved.svg";
import declined from "../../../../../../Assets/MainComponent/decline.svg";
import pending from "../../../../../../Assets/MainComponent/pending.svg";
import BackImage from "../../../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";

import correctIcons from "../../../../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../../../../Assets/AppComponent/icons/Group 145.svg";


const ReimbursementEMP = () => {
  const EnglishData = data;
  const HindiData = hindiDatas;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [createEditPopup, setCreateEditPopup] = useState(false);
  const [editPayload, setEditPayload] = useState({});
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [sno, setsno] = useState(0);

  const FileterState = {
    status: ""
  }
  const [selectVal, SetSelectval] = useState(FileterState);
  const [OptionValues, setOptionvalues] = useState([{ value: "", label: "All" }])

  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Rejected" },
    { value: "approved", label: "Approved" },
  ];
  const [search, setsearch] = useState("")

  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const responseData = useSelector(
    (state) => state.FetchReimbursementCall.fetchReimbursementFeedData
  );
  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  useEffect(() => {
    const payload = {
      page_size: 10,
      page: dtpageindex,
      status: selectVal.status,
      search: search
    };
    dispatch(SetFetchReimbursementEMPAction(payload));
  }, [selectVal, dtpageindex, search]);

  const ClearState = (counts) => {
    setOptionvalues({ value: "", label: "All" })
    SetSelectval({
      ...selectVal,
      status: "",

    });
  };

  const count = (Counts, values, sel, SelectedValues) => {
    setOptionvalues(SelectedValues)
    SetSelectval({
      ///Completed
      ...selectVal,
      status: SelectedValues.value
    });
  };

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const dispatchApiCall = (payload) => {
    dispatch(SetFetchReimbursementEMPAction(payload));
  };
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  const columns =
    useMemo(
      () => [
        {
          Header: "S.NO",
          accessor: "",
          Cell: (row) => {
            console.log(row.row);
            console.log(sno);
            return <p>{Number(sno + row.row.index + 1)}</p>;
          },
        },
        {
          Header: "CATEGORY",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                {row.row.original.reason_type != undefined ? (
                  <span >
                    {capitalizeFirstLetter(row.row.original.reason_type)}
                  </span>
                ) : (
                  <span>{"Not mention"}</span>
                )}
              </>
            );
          },
        },

        {
          Header: "AMOUNT",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                <p
                // data-tooltip-id="my-tooltip"
                // data-tooltip-content={`${formattedTime}`}
                >
                  {row.row.original.amount}
                </p>
              </>
            );
          },
        },
        {
          Header: "APPLIED DATE",
          accessor: "",
          Cell: (row) => {
            const dateString = row.row.original.created_at;
            const dateObject = new Date(dateString);
            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            const twelveHourFormat = hours % 12 || 12;

            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

            const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

            return (
              <>
                <span>
                  {`${row.row.original.created_at.slice(0, 10) + "  " + formattedTime
                    }`}
                </span>
              </>
            );
          },
        },

        {
          Header: "APPROVED DATE",
          accessor: "",
          Cell: (row) => {
            const dateString = row.row.original.approved_date;

            // Check if approved_date is null or empty
            if (!dateString) {
              return <span>--</span>; // Display -- if approved_date is null
            }

            const dateObject = new Date(dateString);
            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            const twelveHourFormat = hours % 12 || 12;

            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

            const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

            return (
              <>
                <span>
                  {`${dateString.slice(0, 10) + "  " + formattedTime}`}
                </span>
              </>
            );
          },
        },
        // {
        //   Header: "STATUS",
        //   accessor: "",
        //   Cell: (row) => {
        //     const originalString = row.row.original.status;
        //     const capitalizedString = capitalizeFirstLetter(originalString);

        //     return (
        //       <>
        //         {row.row.original.status != undefined ? (
        //           <>
        //             <img
        //               src={
        //                 row.row.original.status == "approved"
        //                   ? approved
        //                   : row.row.original.status === "pending"
        //                     ? pending
        //                     : declined
        //               }
        //               alt="img"
        //               // width={"20px"}
        //               // height={"20px"}
        //               className="ReimbursementIconImages"
        //             />
        //             &nbsp;
        //             <span>
        //               {row.row.original.status == "approved"
        //                 ? "Approved"
        //                 : row.row.original.status === "pending"
        //                   ? "Pending"
        //                   : "Decline"}
        //             </span>
        //           </>
        //         ) : (

        //           <span>{"--"}</span>
        //         )}
        //       </>
        //     );
        //   },
        // },
        {
          Header: "STATUS",
          accessor: "status",
          Cell: (row) => {
            const originalString = row.row.original.status;
            const capitalizedString = capitalizeFirstLetter(originalString);
            return (
              <>
                {row.row.original.status != undefined ? (
                  <>
                    {row.row.original.status.toLowerCase() == "pending" ? (
                      <div className="StatusList">
                        <img src={Pendingimg} />
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "decline" ? (
                          <div className="StatusList">
                            <div className="DeclineStatus">
                              <span>x</span>
                            </div>
                            <span>{capitalizedString}</span>
                          </div>
                        ) : (
                          <>
                            {row.row.original.status.toLowerCase() == "approved" ? (
                              <div className="StatusList">
                                <img src={correctIcons} />
                                <span>{capitalizedString}</span>
                              </div>
                            ) : null}
                          </>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <span>---</span>
                )}
              </>
            );
          },
        },
      ], [sno]
    );
  var ParamsObject = {
    page_size: 10,
    page: dtpageindex,
    status: selectVal.status,
    search: search
  }
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>

        <div className="leaveWrapper">
          {/* <HeadingComp
          english={EnglishData.reimbursement.heading}
          hindi={HindiData.reimbursement.heading}
        /> */}
          <div className="row">
            <div className="col-12 leaveHeading text-left">
              <h3>REIMBURSEMENT</h3>
            </div>
          </div>

          <div
            className="row Filters ButtonPrevious"
            style={{
              padding: "4px",
              margin: "0px",
              position: "relative",
              zIndex: "30",
              marginLeft: "-16px",
              marginRight: "0px",
            }}
          >
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate("/employment");
                }}
              >
                <img className="PreviousPages" src={BackImage} />
                <span></span>

              </button>
            </div>
            <button
              className="customButton  ButtonCSS"
              onClick={() => {
                setCreateEditPopup(true);
              }}
              style={{ background: "#ef4d39", color: "white" }}
            >
              {/* {useLanguageSelector(
                EnglishData.leave.applyButton,
                HindiData.leave.applyButton
              )} */}

              Apply
            </button>
          </div>
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-12 leaveSubHeading">
              <ReactTable
                data={responseData}
                datacount={10}
                columns={columns}
                // dispatchApiCall={dispatchApiCall}
                pagesize={pagesize}
                dtpagesize={20}
                dtpageindex={dtpageindex}
                pageindex={pageindex}
                Search={true}
                onPrevious={handlePrevious}
                onNextpage={handleNext}
                GotoEnteredPage={GotoEnteredPage}
                Filter={true}
                values={OptionValues}
                options={options}
                count={count}
                ClearState={ClearState}
                onChange={tochange}
                setsno={setsno}
                sno={sno}
                id={"spe"}

              />

            </div>
          </div>
        </div>
      </div>
      {createEditPopup == true && (
        <ReimbursementPopup
          show={createEditPopup}
          setShow={setCreateEditPopup}
          editPayload={editPayload}
          setEditPayload={setEditPayload}
          GetFilter={ParamsObject}
        />
      )}
    </>
  );
};

export default ReimbursementEMP;
